module.exports = __webpack_public_path__ + "assets/goals-minutes-day.8ed38197.svg";